(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const parse = (el) => { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* stockage indisponible */ } },
    del(k) { try { localStorage.removeItem(k); } catch (e) { /* stockage indisponible */ } }
  };
  const CFG = parse($('#ec-data')) || {};
  const money = (c) => (Number(c || 0) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };
  ESC[String.fromCharCode(34)] = '&quot;';
  ESC[String.fromCharCode(39)] = '&#39;';
  const ESC_RE = new RegExp('[&<>' + String.fromCharCode(34, 39) + ']', 'g');
  const esc = (s) => String(s == null ? '' : s).replace(ESC_RE, (c) => ESC[c]);
  const imgW = (u, w) => (u ? `${u}${u.indexOf('?') > -1 ? '&' : '?'}width=${w}` : '');
  const refocus = (el) => { if (el && el.focus) el.focus({ preventScroll: true }); };
  const smooth = () => (reduce.matches ? 'auto' : 'smooth');

  /* ---------- Illustration du seau ---------- */
  const bucketArt = () => `<svg viewBox='0 0 150 170' aria-hidden='true' focusable='false'><path d='M38 40C38 8 112 8 112 40' fill='none' stroke='#A08A79' stroke-width='4'/><path d='M23 70H127L118 156Q117 164 109 164H41Q33 164 32 156Z' fill='#3F8A97' opacity='.75'/><path d='M20 40H130L118 156Q117 164 109 164H41Q33 164 32 156Z' fill='none' stroke='#2A211C' stroke-width='4' stroke-linejoin='round'/><path d='M16 40H134' stroke='#2A211C' stroke-width='6' stroke-linecap='round'/></svg>`;
  $$('[data-ec-art=bucket]').forEach((el) => el.insertAdjacentHTML('beforeend', bucketArt()));

  /* ---------- En-tête et menus ---------- */
  const header = $('[data-ec-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  $$('[data-ec-menu]').forEach((wrap) => {
    const btn = $('button', wrap);
    btn.addEventListener('click', () => {
      const open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
  });

  /* ---------- Tiroirs ---------- */
  const scrim = $('[data-ec-scrim]');
  let openDrawer = null;
  let lastFocus = null;
  function trap(e, box) {
    if (e.key !== 'Tab') return;
    const f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea', box).filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openD(name) {
    const d = $(`[data-ec-drawer=${name}]`);
    if (!d) return;
    if (openDrawer && openDrawer !== d) closeD(true);
    if (!openDrawer) lastFocus = document.activeElement;
    openDrawer = d;
    d.removeAttribute('inert');
    d.classList.add('is-open');
    if (scrim) scrim.classList.add('is-on');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => { const c = $('[data-ec-close]', d); refocus(c || d); }, 80);
  }
  function closeD(silent) {
    if (!openDrawer) return;
    const d = openDrawer;
    openDrawer = null;
    d.classList.remove('is-open');
    d.setAttribute('inert', '');
    if (scrim) scrim.classList.remove('is-on');
    document.documentElement.style.overflow = '';
    if (!silent) refocus(lastFocus);
  }
  $$('[data-ec-drawer]').forEach((d) => { d.setAttribute('inert', ''); d.addEventListener('keydown', (e) => trap(e, d)); });
  if (scrim) scrim.addEventListener('click', () => closeD());
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-ec-open]');
    if (o) { e.preventDefault(); openD(o.dataset.ecOpen); return; }
    if (openDrawer && e.target.closest('[data-ec-close]')) closeD();
  });

  /* ---------- Panier ---------- */
  let cart = parse($('#ec-cart-json'));
  const upsell = parse($('#ec-upsell'));
  const cBody = $('[data-ec-cart-body]');
  const cFoot = $('[data-ec-cart-foot]');
  async function api(path, data) {
    const opts = data
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }
      : { headers: { Accept: 'application/json' } };
    const res = await fetch(path, opts);
    const out = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(out.description || out.message || 'Indisponible');
    return out;
  }
  const isRech = (h) => /recharge|capsule|cartouche/.test(String(h || ''));
  async function refresh() { cart = await api(`${CFG.cartUrl}.js`); renderCart(); }
  function upsellHTML() {
    if (!upsell || !upsell.variants || !cart) return '';
    const hasShower = cart.items.some((i) => !isRech(i.handle));
    const hasRech = cart.items.some((i) => i.product_id === upsell.id);
    if (!hasShower || hasRech) return '';
    const v = upsell.variants.find((x) => x.available);
    if (!v) return '';
    const pic = upsell.featured_image ? `<img src='${esc(imgW(upsell.featured_image, 120))}' alt=''>` : '<span></span>';
    return `<div class='ec-upsell'>${pic}<p><strong>Pensez aux recharges</strong><br>${esc(upsell.title)} · ${money(v.price)}</p><button type='button' class='ec-btn ec-btn-ghost' data-ec-add='${v.id}'><span data-ec-label>Ajouter</span></button></div>`;
  }
  function renderCart() {
    if (!cart || !cart.items) return;
    const n = cart.item_count;
    $$('[data-ec-count]').forEach((c) => { c.textContent = n; c.classList.toggle('is-empty', n === 0); });
    const cn = $('[data-ec-cart-n]');
    if (cn) cn.textContent = n ? `(${n})` : '';
    if (!cBody) return;
    if (!n) {
      cBody.innerHTML = `<div class='ec-empty'><p class='ec-h3'>Votre panier est vide.</p><p class='ec-muted'>Une vraie douche vous attend.</p><a class='ec-btn ec-btn-primary' href='${esc(CFG.productUrl || '/')}' data-ec-close>Voir le pommeau</a></div>`;
      cFoot.hidden = true;
      return;
    }
    cBody.innerHTML = cart.items.map((it) => {
      const media = it.image ? `<img src='${esc(imgW(it.image, 160))}' alt='' width='72' height='72' loading='lazy'>` : '';
      const sub = it.product_has_only_default_variant ? '' : `<p class='ec-line-sub'>${esc(it.variant_title || '')}</p>`;
      return `<div class='ec-line'><a class='ec-line-media' href='${esc(it.url)}' tabindex='-1' aria-hidden='true'>${media}</a><div><p class='ec-line-name'><a href='${esc(it.url)}'>${esc(it.product_title)}</a></p>${sub}<div class='ec-qty'><button type='button' aria-label='Retirer un article' data-ec-q='${esc(it.key)}' data-n='${it.quantity - 1}'><svg class='ec-i'><use href='#i-minus'/></svg></button><span>${it.quantity}</span><button type='button' aria-label='Ajouter un article' data-ec-q='${esc(it.key)}' data-n='${it.quantity + 1}'><svg class='ec-i'><use href='#i-plus'/></svg></button></div></div><div><p class='ec-line-price'>${money(it.final_line_price)}</p><button type='button' class='ec-remove' data-ec-q='${esc(it.key)}' data-n='0'>Retirer</button></div></div>`;
    }).join('') + upsellHTML();
    cFoot.hidden = false;
    const root = String(CFG.root || '/').replace(/[/]$/, '');
    cFoot.innerHTML = `<p class='ec-sub'><span>Livraison</span><span>Offerte</span></p><p class='ec-total'><span>Total</span><span>${money(cart.total_price)}</span></p><a class='ec-btn ec-btn-primary ec-btn-block' href='${root}/checkout'>Passer commande</a><p class='ec-help'>Code −10 % à saisir au paiement. 30 jours satisfait ou remboursé.</p>`;
  }
  function bump() { $$('[data-ec-count]').forEach((c) => { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }); }
  async function addItem(id, btn, qty) {
    if (!id) return;
    const label = (btn && $('[data-ec-label]', btn)) || null;
    const prev = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    try {
      await api(`${CFG.cartAddUrl}.js`, { items: [{ id, quantity: qty || 1 }] });
      await refresh();
      if (btn) btn.classList.add('is-done');
      if (label) label.textContent = 'Ajouté';
      bump();
      openD('cart');
    } catch (err) {
      if (label) label.textContent = err.message || 'Indisponible';
    }
    setTimeout(() => { if (btn) { btn.disabled = false; btn.classList.remove('is-done'); } if (label) label.textContent = prev; }, 1800);
  }
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-ec-q]');
    if (q) {
      q.disabled = true;
      try { cart = await api(`${CFG.cartChangeUrl}.js`, { id: q.dataset.ecQ, quantity: Math.max(0, Number(q.dataset.n)) }); renderCart(); } catch (err) { q.disabled = false; }
      return;
    }
    const a = e.target.closest('[data-ec-add]');
    if (a && a.dataset.ecAdd) { e.preventDefault(); addItem(Number(a.dataset.ecAdd), a, Number(a.dataset.ecQty) || 1); }
  });
  renderCart();

  /* ---------- Anatomie du pommeau ---------- */
  $$('[data-ec-anat]').forEach((box) => {
    const set = (k) => $$('[data-k]', box).forEach((el) => el.classList.toggle('is-on', el.dataset.k === k));
    box.addEventListener('click', (e) => { const t = e.target.closest('[data-k]'); if (t) set(t.dataset.k); });
    box.addEventListener('mouseover', (e) => { const t = e.target.closest('[data-k]'); if (t) set(t.dataset.k); });
    set('2');
  });

  /* ---------- Test du seau (simplifié) ---------- */
  const seau = $('[data-ec-seau]');
  if (seau) {
    const CLASSIC = 10;
    const CG = 7;
    const MIN = 8;
    const WATER = 4.3 / 1000;
    const KWH_L = 0.0336;
    const KWH = 0.25;
    let ppl = 2;
    const shown = { euros: 0, liters: 0 };
    const out = (k) => $(`[data-ec-out=${k}]`, seau);
    const nf = (n) => Math.round(n).toLocaleString('fr-FR');
    const tween = (k, to, fmt, instant) => {
      const el = out(k);
      if (!el) return;
      const from = shown[k];
      shown[k] = to;
      if (instant || reduce.matches) { el.textContent = fmt(to); return; }
      const t0 = performance.now();
      const tick = (t) => {
        const x = Math.min(1, (t - t0) / 800);
        el.textContent = fmt(from + (to - from) * (1 - Math.pow(1 - x, 3)));
        if (x < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const calc = (instant) => {
      const liters = (CLASSIC - CG) * MIN * ppl * 365;
      const euros = liters * WATER + liters * KWH_L * KWH;
      tween('euros', euros, (v) => `${nf(v)} €`, instant);
      tween('liters', liters, (v) => `${nf(v)} litres d’eau en moins par an`, instant);
    };
    $$('[data-ec-ppl]', seau).forEach((b) => b.addEventListener('click', () => {
      ppl = Number(b.dataset.ecPpl);
      $$('[data-ec-ppl]', seau).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      calc(false);
    }));
    calc(true);
    const lv = $$('[data-ec-lvl]', seau);
    const fill = () => lv.forEach((r) => { r.style.transform = `scaleY(${(Number(r.dataset.ecLvl) / 12).toFixed(3)})`; });
    if (reduce.matches) fill();
    else {
      lv.forEach((r) => { r.style.transform = 'scaleY(0)'; });
      new IntersectionObserver((en, ob) => {
        if (!en[0].isIntersecting) return;
        ob.disconnect();
        fill();
        shown.euros = 0;
        shown.liters = 0;
        calc(false);
      }, { threshold: 0.35 }).observe(seau);
    }
  }

  /* ---------- Bloc d’achat ---------- */
  const SCENT = { citron: '#F2C230', rose: '#E8457A', lavande: '#9B59D0', jasmin: '#E6DCC2' };
  const scentColor = (v) => SCENT[String(v || '').toLowerCase()] || '#C9B8A6';
  function offerInfo(name) {
    const n = String(name || '').toLowerCase();
    if (/duo/.test(n)) return { key: 'duo', sub: '2 pommeaux, capsules citron · le 2e à -30 %', box: ['2 Pommeaux C-Glow', '2 capsules vitamine C citron (déjà dans les pommeaux)', '2 joints d’étanchéité'], img: 1, flag: 'Le 2e à -30 %', bundle: true };
    if (/pack|capsules|mois/.test(n)) return { key: 'pack', sub: '1 pommeau + 3 capsules · parfum au choix', box: ['1 Pommeau C-Glow', '1 capsule vitamine C (déjà dans le pommeau)', '3 capsules de recharge au parfum choisi', '1 joint d’étanchéité'], img: 2, flag: 'Notre conseil', bundle: true };
    return { key: 'essentiel', sub: '1 pommeau + 1 capsule vitamine C citron', box: ['1 Pommeau C-Glow', '1 capsule vitamine C citron (déjà dans le pommeau)', '1 joint d’étanchéité'], img: 0, bundle: false };
  }
  function demoProduct() {
    const all = ['Citron', 'Rose', 'Lavande', 'Jasmin'];
    const offers = [['L’Essentiel', 4290, null, ['Citron']], ['Pack 3 capsules', 5490, 5780, all]];
    const variants = [];
    offers.forEach(([o, pr, c, scents]) => scents.forEach((s) => variants.push({ id: 0, title: `${o} / ${s}`, options: [o, s], price: pr, compare_at_price: c, available: true })));
    return { options: ['Offre', 'Parfum'], variants };
  }
  const boxes = [];
  $$('[data-ec-bb]').forEach((root) => boxes.push(buybox(root)));
  function buybox(root) {
    let P = parse($('[data-ec-product]', root));
    const demo = !P || !Array.isArray(P.variants) || !P.variants.length;
    if (demo) P = demoProduct();
    const photos = parse($('[data-ec-photos]', root)) || [];
    const names = (P.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    const vals = (v) => v.options || [v.option1, v.option2, v.option3].filter((x) => x != null);
    const uniq = (i) => Array.from(new Set(P.variants.map((v) => vals(v)[i])));
    const iOffer = names.findIndex((o) => /offre|offer|formule|pack/i.test(o));
    const i2 = names.findIndex((o, i) => i !== iOffer && uniq(i).length > 1);
    const sel = vals(P.variants.find((v) => v.available) || P.variants[0]).slice();
    if (iOffer > -1) { const pk = uniq(iOffer).find((v) => offerInfo(v).key === 'pack'); if (pk) sel[iOffer] = pk; }
    const q = (s) => $(s, root);
    const offersEl = q('[data-ec-offers]');
    const chipsEl = q('[data-ec-chips]');
    const otherEl = q('[data-ec-other]');
    const main = q('[data-ec-gal-main]');
    const thumbs = q('[data-ec-thumbs]');
    const atc = q('[data-ec-atc]');
    const atcL = atc ? $('[data-ec-label]', atc) : null;
    const uid = Math.random().toString(36).slice(2, 7);
    const findV = (t) => P.variants.find((v) => vals(v).every((x, i) => x === t[i]));
    // Duo : 2 × L’Essentiel du même parfum, le 2e à -30 % (réduction automatique Shopify)
    const DUO = 'Duo';
    const essV = iOffer > -1 ? uniq(iOffer).find((v) => offerInfo(v).key === 'essentiel') : null;
    const virtualDuo = !!essV && !uniq(iOffer).some((v) => offerInfo(v).key === 'duo');
    const offerVals = () => (virtualDuo ? uniq(iOffer).concat(DUO) : uniq(iOffer));
    const match = (t) => {
      if (!virtualDuo || t[iOffer] !== DUO) return findV(t);
      const e = t.slice();
      e[iOffer] = essV;
      const v = findV(e);
      return v ? Object.assign({}, v, { price: v.price + Math.round(v.price * 0.7), compare_at_price: v.price * 2, qty: 2 }) : null;
    };
    // Variante de l’offre avec le parfum choisi, sinon avec le premier parfum disponible (L’Essentiel et Duo : citron)
    const scentFor = (t) => (i2 < 0 ? null : uniq(i2).find((s) => { const u = t.slice(); u[i2] = s; return !!match(u); }));
    const matchAny = (t) => {
      const v = match(t);
      if (v || i2 < 0) return v;
      const s = scentFor(t);
      if (!s) return null;
      const u = t.slice();
      u[i2] = s;
      return match(u);
    };

    if (main && !$('img', main) && photos.length) {
      main.innerHTML = `<img src='${esc(photos[0].src)}' alt='${esc(photos[0].alt)}' width='1200' height='1200'>`;
      if (thumbs) thumbs.innerHTML = photos.map((p, k) => `<button type='button' class='ec-thumb' aria-label='Photo ${k + 1}' aria-current='${k === 0}' data-ec-src='${esc(p.src)}' data-ec-alt='${esc(p.alt)}'><img src='${esc(imgW(p.src, 240))}' alt='' loading='lazy'></button>`).join('');
    }
    function showImage(src, alt) {
      const im = main && $('img', main);
      if (!im || !src) return;
      im.removeAttribute('srcset');
      im.src = src.indexOf('//') === 0 ? `https:${src}` : src;
      if (alt) im.alt = alt;
      im.classList.remove('is-swap');
      void im.offsetWidth;
      im.classList.add('is-swap');
      if (thumbs) $$('.ec-thumb', thumbs).forEach((t) => t.setAttribute('aria-current', String(t.dataset.ecSrc === src)));
    }
    if (thumbs) thumbs.addEventListener('click', (e) => { const b = e.target.closest('.ec-thumb'); if (b) showImage(b.dataset.ecSrc, b.dataset.ecAlt); });

    if (offersEl && iOffer > -1) {
      offersEl.innerHTML = offerVals().map((o) => {
        const info = offerInfo(o);
        return `<label class='ec-offer' data-v='${esc(o)}'>${info.flag ? `<span class='ec-offer-flag'>${info.flag}</span>` : ''}<input type='radio' name='offer-${uid}' value='${esc(o)}'${sel[iOffer] === o ? ' checked' : ''}><span class='ec-offer-dot' aria-hidden='true'></span><span><strong>${esc(o)}</strong><small>${info.sub}</small></span><span class='ec-offer-price' data-ec-op></span></label>`;
      }).join('');
      offersEl.addEventListener('change', (e) => { sel[iOffer] = e.target.value; update(true); });
    } else if (offersEl) offersEl.closest('fieldset').hidden = true;

    if (chipsEl && i2 > -1) {
      const nm = q('[data-ec-opt2-name]');
      if (nm) nm.textContent = names[i2];
      chipsEl.innerHTML = uniq(i2).map((v) => `<label class='ec-chip'><input type='radio' name='opt2-${uid}' value='${esc(v)}'${sel[i2] === v ? ' checked' : ''}><span><i style='--dot:${scentColor(v)}'></i>${esc(v)}</span></label>`).join('');
      chipsEl.addEventListener('change', (e) => { sel[i2] = e.target.value; update(false); });
    } else if (chipsEl) chipsEl.closest('fieldset').hidden = true;

    if (otherEl) {
      names.forEach((o, i) => {
        if (i === iOffer || i === i2) return;
        const list = uniq(i);
        if (list.length < 2) return;
        otherEl.insertAdjacentHTML('beforeend', `<div class='ec-field'><label class='ec-label' for='o-${uid}-${i}'>${esc(o)}</label><select class='ec-select' id='o-${uid}-${i}' data-i='${i}'>${list.map((v) => `<option${sel[i] === v ? ' selected' : ''}>${esc(v)}</option>`).join('')}</select></div>`);
      });
      otherEl.addEventListener('change', (e) => { const i = Number(e.target.dataset.i); sel[i] = e.target.value; update(false); });
    }

    const priceEl = q('[data-ec-price]');
    const cmpEl = q('[data-ec-compare]');
    const lab2 = q('[data-ec-opt2-label]');
    const inbox = q('[data-ec-inbox]');
    const satcEl = root.hasAttribute('data-ec-main') ? $('[data-ec-satc]') : null;

    function update(offerChanged) {
      if (i2 > -1 && !match(sel)) {
        const s = scentFor(sel);
        if (s) { sel[i2] = s; $$(`input[name=opt2-${uid}]`, root).forEach((x) => { x.checked = x.value === s; }); }
      }
      const v = match(sel);
      const info = offerInfo(iOffer > -1 ? sel[iOffer] : '');
      if (chipsEl && i2 > -1) {
        $$('.ec-chip input', chipsEl).forEach((x) => {
          const t = sel.slice();
          t[i2] = x.value;
          const ok = !!match(t);
          x.disabled = !ok;
          x.closest('.ec-chip').classList.toggle('is-off', !ok);
        });
      }
      const note = q('[data-ec-scent-note]');
      if (note) note.hidden = !(info.key === 'essentiel' || info.key === 'duo');
      $$('.ec-offer', root).forEach((l) => {
        l.classList.toggle('is-checked', l.dataset.v === sel[iOffer]);
        const t = sel.slice();
        t[iOffer] = l.dataset.v;
        const pv = matchAny(t);
        const ps = $('[data-ec-op]', l);
        if (ps) ps.innerHTML = pv ? `${money(pv.price)}${pv.compare_at_price > pv.price ? `<s>${money(pv.compare_at_price)}</s>` : ''}` : '';
      });
      if (lab2 && i2 > -1) lab2.textContent = sel[i2];
      if (priceEl) priceEl.textContent = v ? money(v.price) : '—';
      if (cmpEl) {
        if (v && v.compare_at_price > v.price) cmpEl.innerHTML = info.bundle ? `Séparément : <s>${money(v.compare_at_price)}</s>` : `<s>${money(v.compare_at_price)}</s>`;
        else cmpEl.textContent = '';
      }
      if (inbox) inbox.innerHTML = info.box.map((b) => `<li>${b}</li>`).join('');
      if (atc) {
        const ok = v && v.available;
        atc.disabled = !ok;
        atc.dataset.ecAdd = ok && !demo ? String(v.id) : '';
        atc.dataset.ecQty = v && v.qty ? String(v.qty) : '1';
        if (atcL) atcL.textContent = !v ? 'Combinaison indisponible' : v.available ? `Ajouter au panier · ${money(v.price)}` : 'Épuisé';
      }
      if (satcEl) {
        const sp = $('[data-ec-satc-price]', satcEl);
        if (sp) sp.textContent = v ? `${iOffer > -1 ? `${sel[iOffer]} · ` : ''}${money(v.price)}` : '';
        const sb = $('[data-ec-satc-btn]', satcEl);
        if (sb && atc) sb.disabled = atc.disabled;
      }
      if (v && v.featured_image) showImage(v.featured_image.src, v.featured_image.alt);
      else if (offerChanged && demo && photos[info.img]) showImage(photos[info.img].src, photos[info.img].alt);
    }

    if (demo && atc) {
      atc.addEventListener('click', () => { const n = q('[data-ec-demo]'); if (n) n.hidden = false; });
    }
    if (satcEl && atc) {
      const sb = $('[data-ec-satc-btn]', satcEl);
      if (sb) sb.addEventListener('click', () => atc.click());
      new IntersectionObserver((en) => {
        const on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        satcEl.classList.toggle('is-on', on);
        satcEl.inert = !on;
        document.body.classList.toggle('has-satc', on);
      }).observe(atc);
    }
    update(false);
    return {
      root,
      select(key) {
        if (iOffer < 0) return;
        const v = offerVals().find((o) => offerInfo(o).key === key);
        if (!v) return;
        sel[iOffer] = v;
        $$(`input[name=offer-${uid}]`, root).forEach((i) => { i.checked = i.value === v; });
        update(true);
      },
      priceOf(key) {
        if (iOffer < 0) return '';
        const o = offerVals().find((x) => offerInfo(x).key === key);
        const t = sel.slice();
        t[iOffer] = o;
        const v = matchAny(t);
        return v ? money(v.price) : '';
      }
    };
  }

  /* ---------- Guide de choix ---------- */
  const GUIDE = {
    essentiel: ['L’Essentiel', 'Le pommeau et sa capsule vitamine C citron. Parfait pour essayer.', 0],
    pack: ['Pack 3 capsules', 'Le pommeau et 3 recharges au parfum de votre choix : vous êtes tranquille plusieurs mois.', 2],
    duo: ['Duo', 'Deux pommeaux, le 2e à -30 % : un pour chaque salle de bain, ou un à offrir.', 1]
  };
  $$('[data-ec-guide]').forEach((gd) => {
    const ans = { sdb: '1', duree: 'essai' };
    const res = $('[data-ec-gres]', gd);
    const photos = parse($('[data-ec-photos]', gd)) || [];
    const bb = boxes[0];
    const render = (anim) => {
      const key = ans.sdb === '2' ? 'duo' : ans.duree === 'long' ? 'pack' : 'essentiel';
      const g = GUIDE[key];
      $('[data-ec-gres-t]', res).textContent = g[0];
      $('[data-ec-gres-d]', res).textContent = g[1];
      const pr = bb ? bb.priceOf(key) : '';
      $('[data-ec-gres-p]', res).textContent = pr;
      const im = $('img', res);
      if (im && photos[g[2]]) { im.src = photos[g[2]].src; im.alt = photos[g[2]].alt; }
      res.dataset.key = key;
      if (anim) { res.classList.remove('is-swap'); void res.offsetWidth; res.classList.add('is-swap'); }
    };
    $$('[data-ec-g]', gd).forEach((b) => b.addEventListener('click', () => {
      ans[b.dataset.ecG] = b.dataset.v;
      $$(`[data-ec-g=${b.dataset.ecG}]`, gd).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      render(true);
    }));
    const cta = $('[data-ec-gres-go]', gd);
    if (cta) cta.addEventListener('click', (e) => {
      if (!bb) return;
      e.preventDefault();
      bb.select(res.dataset.key);
      bb.root.scrollIntoView({ behavior: smooth(), block: 'start' });
    });
    render(false);
  });

  /* ---------- Raccourcis vers une offre ---------- */
  document.addEventListener('click', (e) => {
    const p = e.target.closest('[data-ec-pick]');
    const bb = boxes[0];
    if (!p || !bb) return;
    e.preventDefault();
    bb.select(p.dataset.ecPick);
    bb.root.scrollIntoView({ behavior: smooth(), block: 'start' });
  });

  /* ---------- Accordéons ---------- */
  $$('.ec-qa').forEach((qa) => {
    const b = $('button', qa);
    const panel = $('.ec-qa-panel > div', qa);
    if (!b || !panel) return;
    const set = (on) => { qa.classList.toggle('is-open', on); b.setAttribute('aria-expanded', String(on)); panel.inert = !on; };
    set(qa.classList.contains('is-open'));
    b.addEventListener('click', () => set(!qa.classList.contains('is-open')));
  });

  /* ---------- Délai de livraison ---------- */
  const shipEls = $$('[data-ec-ship]');
  if (shipEls.length) {
    const addBiz = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); const w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; };
    const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    const now = new Date();
    const txt = `Livraison suivie et offerte. Commandez aujourd’hui, recevez-le entre le <b>${fmt.format(addBiz(now, 5))}</b> et le <b>${fmt.format(addBiz(now, 10))}</b>.`;
    shipEls.forEach((el) => { el.innerHTML = txt; });
  }

  /* ---------- Quiz −10 % ---------- */
  const quiz = $('[data-ec-quiz]');
  let quizOpen = false;
  let qLast = null;
  const QA = {
    filet: ['Le Pommeau C-Glow est fait pour vous.', 'Ses micro-trous accélèrent l’eau : le jet reste fort, même quand la pression arrive faible.'],
    peau: ['La vitamine C va vous plaire.', 'La capsule neutralise le chlore : l’eau est plus douce et la peau tire moins après la douche.'],
    chlore: ['Fini l’odeur de piscine.', 'La capsule vitamine C neutralise le chlore et parfume légèrement votre douche.']
  };
  function showStep(n) {
    $$('[data-ec-step]', quiz).forEach((st) => { st.hidden = st.dataset.ecStep !== String(n); });
    $$('.ec-dots i', quiz).forEach((d, i) => d.classList.toggle('is-on', i < n));
  }
  function openQuiz(step) {
    if (!quiz) return;
    closeD(true);
    qLast = document.activeElement;
    quiz.hidden = false;
    quizOpen = true;
    showStep(step);
    store.set('ec-quiz-seen', '1');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => {
      const st = $(`[data-ec-step='${step}']`, quiz);
      const t = st && $('.ec-opt, input[type=email], [data-ec-copy]', st);
      refocus(t || $('.ec-modal-close', quiz));
    }, 80);
  }
  function closeQuiz() {
    if (!quiz || !quizOpen) return;
    quiz.hidden = true;
    quizOpen = false;
    document.documentElement.style.overflow = '';
    refocus(qLast);
  }
  if (quiz) {
    quiz.addEventListener('keydown', (e) => trap(e, quiz));
    quiz.addEventListener('click', (e) => {
      if (e.target.closest('[data-ec-quiz-close]')) { closeQuiz(); return; }
      const a = e.target.closest('[data-ec-answer]');
      if (!a) return;
      const k = a.dataset.ecAnswer;
      const pair = QA[k] || QA.filet;
      $('[data-ec-q-title]', quiz).textContent = pair[0];
      $('[data-ec-q-text]', quiz).textContent = pair[1];
      const tags = $('[data-ec-tags]', quiz);
      if (tags) tags.value = `newsletter,c-glow,besoin-${k}`;
      showStep(2);
      setTimeout(() => { refocus($('input[type=email]', quiz)); }, 80);
    });
    $$('[data-ec-quiz-open]').forEach((b) => b.addEventListener('click', () => openQuiz(1)));
    if (document.body.classList.contains('ec-index') && !store.get('ec-quiz-seen')) {
      const onS = () => {
        const h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h > 0.45) {
          window.removeEventListener('scroll', onS);
          if (!openDrawer && !store.get('ec-quiz-seen')) openQuiz(1);
        }
      };
      window.addEventListener('scroll', onS, { passive: true });
    }
  }
  document.addEventListener('keydown', (e) => { if (e.key !== 'Escape') return; if (quizOpen) closeQuiz(); else closeD(); });

  /* ---------- Formulaires email ---------- */
  const EMAIL = /^[^ @]+@[^ @]+[.][^ @]{2,}$/;
  $$('form.ec-sub').forEach((f) => {
    const input = $('input[type=email]', f);
    const err = $('[data-ec-err]', f);
    if (!input) return;
    f.addEventListener('submit', (e) => {
      if (!EMAIL.test(input.value.trim())) {
        e.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        if (err) err.hidden = false;
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      if (err) err.hidden = true;
      store.set('ec-sub-src', f.closest('[data-ec-quiz]') ? 'quiz' : 'news');
    });
    input.addEventListener('input', () => {
      if (input.getAttribute('aria-invalid') && EMAIL.test(input.value.trim())) { input.removeAttribute('aria-invalid'); if (err) err.hidden = true; }
    });
  });
  if ($('[data-ec-posted]')) {
    const src = store.get('ec-sub-src');
    store.del('ec-sub-src');
    store.set('ec-quiz-seen', '1');
    if (src === 'quiz') openQuiz(3);
  }
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-ec-copy]');
    if (!c) return;
    const selectCode = () => {
      const b = c.parentElement && $('b', c.parentElement);
      if (!b) return;
      const r = document.createRange();
      r.selectNodeContents(b);
      const s = window.getSelection();
      s.removeAllRanges();
      s.addRange(r);
    };
    const done = () => { c.textContent = 'Copié'; setTimeout(() => { c.textContent = 'Copier'; }, 1600); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText('BIENVENUE10').then(done).catch(selectCode);
    else selectCode();
  });
})();
